interface TextProps {
    variant?: 'default' | 'secondary' | 'small' | 'error'
    className?: string
    children: React.ReactNode
    as?: 'p' | 'span' | 'div'
}

export function Text({ variant = 'default', className = '', children, as = 'p' }: TextProps) {
    const variantStyles = {
        default: 'text-text-primary text-base',
        secondary: 'text-text-secondary text-sm',
        small: 'text-text-secondary text-xs',
        error: 'text-red-500 text-sm',
    }

    const Component = as
    const combinedClassName = `${variantStyles[variant]} ${className}`

    return <Component className={combinedClassName}>{children}</Component>
}
